import React from "react";
import ptBr from "../../config/texts/pt-br";
import Styles from "./styles";
import { Spacing, fonts } from "../../config";
import Texts from "../../config/texts";
import { LocalStorage } from "../../utils";

function PrivacyPolicy() {
  const texts = Texts[LocalStorage.getItem("language") ?LocalStorage.getItem("language"): 'pt'].privacyPolicy;

  const [menuHeight, setHeight] = React.useState<any>(null);

  React.useLayoutEffect(() => {
    if (!menuHeight) {
      const mh = document.getElementById("header-menu")?.offsetHeight;

      setHeight(mh);
    }
  }, [menuHeight]);

  return (
    <>
      <Styles.Container $menuHeight={menuHeight}>
        <Styles.Logo />
      </Styles.Container>
      <Styles.PrivacyContainer>
        <Styles.Item>
          <Styles.Title>{texts.title}</Styles.Title>
          <Styles.Description
            style={{
              fontFamily: fonts.regular,
              fontSize: Spacing(2),
              padding: 0,
              margin: 0,
            }}
          >
            {texts.text}
          </Styles.Description>
        </Styles.Item>
      </Styles.PrivacyContainer>
    </>
  );
}

export default PrivacyPolicy;
